<template>
  <a-card title="工单ai业务域值班报表">
    <a-calendar v-model="value" mode="month" @panelChange="handlePanelChange">
      <template #dateCellRender="moment">
        <a-tag v-for="item in getTagArray(moment)" :key="item" color="blue">{{ item }}</a-tag>
      </template>
    </a-calendar>
  </a-card>
</template>

<script>
import { getAIDailyOwner } from '@/api/event/problem';

export default {
  props: {
    userList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      configData: null,
      value: null,
      month: null,
      year: null
    };
  },
  mounted() {
    this.getConfigList();
  },
  methods: {
    handlePanelChange(value, mode) {
      if (mode === 'month') {
        this.value = value;
        this.year = value.year();
        this.month = value.month() + 1;
        this.getConfigList();
      }
    },
    getTagArray(value) {
      const date = value.format('YYYY-MM-DD');
      if (this.configData && Object.prototype.hasOwnProperty.call(this.configData, date)) {
        const userData = [];
        if (this.userList != null) {
          for (let i = 0; i < this.configData[date].length; i++) {
            for (let j = 0; j < this.configData[date][i].length; j++) {
              const uid = this.configData[date][i][j];
              const uer = this.userList.find(item => item.fs_user_id === uid);
              if (uer && uer.name != null) {
                userData.push(uer.name);
              }
            }
          }
        }
        // if (this.userList != null) {
        //   for (let i = 0; i < this.userList.length; i++) {
        //     if (this.configData[date].includes(this.userList[i].fs_user_id)) {
        //       userData.push(this.userList[i].nickname);
        //     }
        //   }
        // }

        return userData;
      }
      return '';
    },
    getConfigList() {
      this.loading = true;
      getAIDailyOwner({ month: this.month, year: this.year })
        .then(res => {
          const __configData = res.data;
          this.configData = __configData;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
